import { MutationTree } from "vuex";
import { CustomFieldsState } from "./types";
import { getDefaultState } from "./state";
import PagedResponse from "@/types/sv-data/PagedResponse";

export const mutations: MutationTree<CustomFieldsState> = {
	setAreaCustomFields(state: CustomFieldsState, fields: PagedResponse) {
		state.areaCustomFields = fields.data;
		state.totalAreaCustomFields = fields.totalRecords;
	},
	setContactCustomFields(state: CustomFieldsState, fields: PagedResponse) {
		state.contactCustomFields = fields.data;
		state.totalContactCustomFields = fields.totalRecords;
	},
	setAlarmCustomFields(state: CustomFieldsState, fields: PagedResponse) {
		state.alarmCustomFields = fields.data;
		state.totalAlarmCustomFields = fields.totalRecords;
	},
	setServerCustomFields(state: CustomFieldsState, fields: PagedResponse) {
		state.serverCustomFields = fields.data;
		state.totalServerCustomFields = fields.totalRecords;
	},
	setDeviceCustomFields(state: CustomFieldsState, fields: PagedResponse) {
		state.deviceCustomFields = fields.data;
		state.totalDeviceCustomFields = fields.totalRecords;
	},
	setNotificationTemplateCustomFields(state: CustomFieldsState, fields: PagedResponse) {
		state.notificationTemplateCustomFields = fields.data;
		state.totalNotificationTemplateCustomFields = fields.totalRecords;
	},
	resetState(state: CustomFieldsState): void {
		Object.assign(state, getDefaultState());
	},
};
